import React from 'react'

import { Link } from 'react-router-dom'

import { LAYOUT_VENDOR_JOB_SHOW } from '../../navigation'

import StatusLabel from '../../../../components/job/status/label'

import { configureField } from '../../../../core/utils/list'

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden } = props

  if (loading) {
    return []
  }

  return [
    {
      title: 'ID #',
      dataIndex: 'job',
      fixed: 'left',
      width: 100,
      ...configureField('j.id', filters, resize, hidden, true, false, false, 100),
      render: (job, record) => {
        if (job) {
          return <Link to={LAYOUT_VENDOR_JOB_SHOW(job.id)}>{job.display_id}</Link>
        }
      }
    },
    {
      title: 'Status',
      dataIndex: 'job',
      ellipsis: true,
      width: 140,
      ...configureField('j.status', filters, resize, hidden, true, false, true, 140),
      // eslint-disable-next-line react/display-name
      render: (job) => {
        if (job) {
          return <StatusLabel status={job.status} />
        }
      }
    },
    {
      title: 'E-ID #',
      dataIndex: 'job',
      width: 100,
      ...configureField('j.eid', filters, resize, hidden, true, false, false, 100),
      render: (job, record) => {
        if (job) {
          return <>{job.eid}</>
        }
      }
    },
    {
      title: 'Name',
      dataIndex: 'job',
      ellipsis: true,
      ...configureField('j.name', filters, resize, hidden, true, true, false, 200),
      render: (job, record) => {
        if (job) {
          return <>{job.name}</>
        }
      }
    },
    {
      title: 'Service',
      dataIndex: 'name',
      width: 300,
      ellipsis: true,
      ...configureField('t.name', filters, resize, hidden, true, false, true, 300),
      // eslint-disable-next-line react/display-name
      render: (name, record) => <>{name}</>
    },
    {
      title: 'Project',
      dataIndex: 'job',
      ...configureField('p.name', filters, resize, hidden, true, false, true, 200),
      // eslint-disable-next-line react/display-name
      render: (job) => {
        return <>{job?.project_name}</>
      }
      //filters: props.projects
    },
    {
      title: 'POS',
      dataIndex: 'job',
      ...configureField('pos.name', filters, resize, hidden, true, false, true, 200),
      // eslint-disable-next-line react/display-name
      render: (job) => {
        return <>{job?.point_of_sale_name}</>
      }
      //filters: props.pointsOfSale,
    }
  ]
}
